'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;
// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _VoucherCard = require('components/Box/VoucherCard');

var _VoucherCard2 = _interopRequireDefault(_VoucherCard);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _support = require('helpers/support');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promotion = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!setupActions.isSeoLoaded(getState())) {
      promises.push(dispatch(setupActions.loadSeo()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    // promotion: state.voucher.promotions,
    province: state.address.province,
    pageSize: state.collections.pageSize,
    loading: state.voucher.loading,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST
  };
}, (0, _extends3.default)({}, voucherActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Promotion, _Component);

  function Promotion(props) {
    (0, _classCallCheck3.default)(this, Promotion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Promotion.__proto__ || (0, _getPrototypeOf2.default)(Promotion)).call(this, props));

    _this.state = {
      pageSize: 1000,
      lazy: false,
      firstLoad: false,
      sort: ''
    };

    _this.getResult = _this.getResult.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Promotion, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loading || !this.props.ALL_REWARD_LIST || !this.state.firstLoad) {
        this.getResult();
      }
      document.addEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading) {
        this.setState({ firstLoad: true });
      }
      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({ pageSize: nextProps.pageSize });
      }
      if (!nextProps.loading) {
        this.setState({ lazy: false });
      }
      if (nextProps.province !== this.props.province) {
        this.getResult();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filter = {
        pageSize: 1000
      };
      this.props.getAllReward(filter);
    }
  }, {
    key: 'isBottom',
    value: function isBottom(el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
  }, {
    key: 'renderCampaign',
    value: function renderCampaign(item, index) {
      var _item = _support.Helper.parsePackageServiceToCard(item);
      return _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 3, key: 'voucherCard_' + index },
        _react2.default.createElement(_VoucherCard2.default, { data: _item })
      );
      // limitDate, handle, address, newPrice, oldPrice, shopName
      // return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Promotion.scss');
      var data = this.props.ALL_REWARD_LIST.data;

      return _react2.default.createElement(
        'div',
        { className: styles.promotionDetail + ' container' },
        _react2.default.createElement(_components.HelmetSEO, { path: 'uu-dai' }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement('div', { className: styles.borderHighlight }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '\u01AFu \u0110\xE3i'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.miniText },
          'C\xE1c spa c\xF3 ch\u01B0\u01A1ng tr\xECnh \u01B0u \u0111\xE3i'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.listPromotion },
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            data && data.map(function (item, index) {
              return _this2.renderCampaign(item, index);
            })
          )
        )
      );
    }
  }]);
  return Promotion;
}(_react.Component), _class2.propTypes = {
  // prominentLoaded: PropTypes.bool,
  // promotion: PropTypes.array,
  getAllReward: _react.PropTypes.func.isRequired,
  pageSize: _react.PropTypes.number,
  ALL_REWARD_LIST: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  province: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = Promotion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Promotion/index.js
// module id = 1689
// module chunks = 0